<div class="modal-header">
  <h4 class="modal-title">{{ title.concat(' List') }}</h4>
  <!--<button type="button" class="modal-close" aria-label="Close" (click)="cancel()">
    <font-awesome [icon]="'fa-regular fa-xmark'"></font-awesome>
  </button>-->
</div>

<div class="modal-body">
  <div class="d-flex">
    <input [(ngModel)]="name" class="form-control rounded"
           placeholder="Name"
           type="text">
  </div>
</div>

<div class="modal-footer">
  <div class="d-flex justify-content-between modal-btn-default">
    <button (click)="close()" class="btn btn-outline-dark wd-153px" type="button">Cancel</button>
    <button (click)="save()" [disabled]="!name" class="btn btn-dark wd-153px" type="button">Save</button>
  </div>
</div>
